import { render, staticRenderFns } from "./AcademicProgressAmend.vue?vue&type=template&id=51806bb5&scoped=true"
import script from "./AcademicProgressAmend.vue?vue&type=script&lang=js"
export * from "./AcademicProgressAmend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51806bb5",
  null
  
)

export default component.exports